export enum UserResponseRole {
  Admin = 'ADMIN',
  AdminMaster = 'ADMIN_MASTER',
  Leadership = 'CHEFIA',
  Assessor = 'ASSESSOR',
}

export enum SpokespersonOperation {
  Keep = 'MANTER',
  Remove = 'REMOVER',
  Update = 'ATUALIZAR',
  Ponder = 'PONDERAR',
}

export enum UploadStatus {
  UPLOADING = 'Enviando planilha',
  UPLOADED = 'Planilha enviada',
  STARTED = 'Início da classificação (IA)',
  FINISHED = 'Processamento finalizado',
  ERRORED = 'Erro. Contacte suporte',
  FINISHED_WITH_WARNINGS = 'Processamento finalizado com avisos',
  INVALID_TEMPLATE = 'Erro no template da planilha',
}

export enum UpdatedQueueStatus {
  STARTED = 'STARTED',
  FINISHED = 'FINISHED',
  ERRORED = 'ERRORED',
}

export enum MentionRole {
  PROTAGONIST = 'Protagonista',
  SUPPORTING = 'Coadjuvante',
  CITATION = 'Citação',
}

export enum PolarityValue {
  UNFAVORABLE = 'DESFAVORAVEL',
  FAVORABLE = 'FAVORAVEL',
  NEGATIVE = 'NEGATIVO',
  NEUTRAL = 'NEUTRO',
  POSITIVE = 'POSITIVO',
  NO_RULE = 'SEM REGRA',
}

export const PolarityID = new Map<PolarityValue, number>([
  [PolarityValue.FAVORABLE, 1],
  [PolarityValue.UNFAVORABLE, 2],
  [PolarityValue.POSITIVE, 3],
  [PolarityValue.NEGATIVE, 4],
  [PolarityValue.NEUTRAL, 5],
  [PolarityValue.NO_RULE, 6],
])

export const EditablePolarityValues = [
  PolarityValue.FAVORABLE,
  PolarityValue.UNFAVORABLE,
  PolarityValue.POSITIVE,
  PolarityValue.NEGATIVE,
]
